import { penToSquare } from "@simplybusiness/icons";
import { Button, Icon, TextOrHTML } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";

export type ContentTextBlockProps = {
  block: string;
  answer: string;
  shouldAddAnswer: boolean;
  hasSensitiveData?: boolean;
  readOnly?: boolean;
  shouldLowercaseAnswer?: boolean;
  onEditQuestion?: () => void;
};

export function ContentTextBlock({
  block,
  answer,
  shouldAddAnswer,
  hasSensitiveData,
  readOnly,
  shouldLowercaseAnswer,
  onEditQuestion,
}: ContentTextBlockProps) {
  const answerClasses = classNames({
    "has-pii": hasSensitiveData,
  });

  // Lowercase the first letter of the answer when it appears in the middle of a sentence
  // e.g., "Your answer is ${answer}." -> "Your answer is yes."
  const casedAnswer =
    shouldLowercaseAnswer && answer
      ? answer.charAt(0).toLowerCase() + answer.slice(1)
      : answer;

  const casedAnswerElement = !readOnly ? (
    <Button
      aria-label={`Edit answer: ${casedAnswer}`}
      variant="link"
      size="sm"
      className={classNames(
        "mobius-collapsible__content-edit-button",
        answerClasses,
      )}
      onClick={() => onEditQuestion?.()}
    >
      {casedAnswer} <Icon icon={penToSquare} title="Edit this answer" />
    </Button>
  ) : (
    casedAnswer
  );

  if (block === "")
    return <strong className={answerClasses}>{casedAnswerElement}</strong>;

  if (shouldAddAnswer)
    return (
      <span>
        <strong className={answerClasses}>{casedAnswerElement}</strong>
        {block}
      </span>
    );

  return <TextOrHTML text={block} />;
}
